import Swal from 'sweetalert2';
import { validateCheckoutWarehouseSplit } from './checkout-warehouse-split.js';
import { validateOrderRows, renameOrderRows } from './validation.js';
import {
    getItemInventory,
    getMultiItemInventory,
    customOrderText,
} from './inventory.js';
import { showModal, hideModal } from '../core/bootstrap-helpers.js';
import { getElementByHashId } from '../core/utilities.js';
import { displayToastrAlert } from '../ui/toastr-alert.js';
import { initQuickOrderModal } from '../quick-order/modal.js';

export { validateOrderRows, renameOrderRows } from './validation.js';
export { customOrderText };

export var _OrderItems = {};
export var _InstantOrderForm = { url: undefined, data: new FormData() };

function postInstantOrder(orderId, poItems, poNumber, isPriceMatch) {
    var action = '/whs/submit_purchase_order';
    var $auInput = $('#au');
    if ($auInput.length) {
        action += '?au=' + $auInput.val();
    }
    var $form = $('<form>', { method: 'post', action: action });
    var addField = function (name, value) {
        $form.append(
            $('<input>', { type: 'hidden', name: name, value: value })
        );
    };
    $.each(poItems || {}, function (rowId, qty) {
        addField('po_items[' + rowId + ']', qty);
    });
    addField('po_number', poNumber);
    addField('pricematch', isPriceMatch ? 'pricematch' : '');
    addField('shipment_type', 'DELIVERY');
    addField('order_notes[' + orderId + ']', '');
    addField('shipping_estimates_serialized', '');
    $form.appendTo('body');
    $form[0].submit();
}

function loadQuickOrderModalLinesFromOrder($orderModal, orderId) {
    if (!orderId) {
        return;
    }
    var viewAsAccount = $('#vaa').length ? '?au=' + $('#vaa').val() : '';
    var $table = $orderModal.find('.multi-order-table tbody');
    var $defaultRow = $table.find('.default-row');
    var appendRows = $orderModal.find('#appendReorder').length;

    $orderModal.find('#appendReorder').remove();

    $.ajax({
        url: '/order/get_order_items/' + orderId + viewAsAccount,
        type: 'get',
        dataType: 'json',
        beforeSend: function () {
            $orderModal
                .find('[type="submit"], .instant-order')
                .prop('disabled', true);
        },
        success: function (data) {
            if (data.length > 0) {
                if (!appendRows) {
                    $table.find('tr').not('.default-row').remove();
                }

                for (var i = 0; i < data.length; i++) {
                    var item = data[i];
                    _OrderItems[item.WHLineCode + '-' + item.PartNumber] =
                        item;
                    var $row = $table.find('.default-row').clone();
                    $row.attr('data-whlc', item.WHLineCode).attr(
                        'data-whsn',
                        item.WHStockNumber
                    );
                    $row.find('.multi-order-brand').val(item.AAIABrandCode);
                    $row.find('.multi-order-part-number').val(item.PartNumber);
                    $row.find('.multi-order-remove').attr(
                        'data-item-id',
                        item.RowID
                    );
                    $row.removeClass('default-row');
                    $row.find('.multi-order-quantity')
                        .val(item.Quantity)
                        .prop('disabled', false);
                    $defaultRow.before($row);
                }

                getMultiItemInventory($table, _OrderItems);

                renameOrderRows($orderModal.find('.multi-order-table'));
            }
        },
    });
}

function calculateOrderCosts() {
    if (typeof window.calculateOrderCosts === 'function') {
        window.calculateOrderCosts();
    }
}

function isExplicitSingleOrderForm($form) {
    var v = $form.attr('data-single-order');
    if (v === undefined || v === null) {
        return false;
    }
    var s = String(v).toLowerCase();
    return String(v) === '1' || s === 'true';
}

/**
 * Multi ordering: open #orderItemModal* so the user picks an order. Modal nodes sit
 * next to browse cards; move to document.body while shown so layout/stacking does
 * not hide the dialog.
 */
function openMultiOrderItemModal($form) {
    var $product = $form.closest('.product-group');
    var quantity = $form.find('.quantity-input').val();
    var orderModalEl = getElementByHashId($form.attr('data-order-modal'));
    var $orderModal = orderModalEl ? $(orderModalEl) : $();

    if (!$orderModal.length) {
        displayToastrAlert(
            'error',
            'Unable to open the order dialog for this product. Try refreshing the page.',
            true
        );
        return;
    }

    var $orderForm = $orderModal.find('form');
    var $quantity = $orderForm
        .find('.multi-order-quantity, .quantity-input')
        .first();

    getItemInventory($orderModal, {
        aaia: $product.attr('data-aaia'),
        partnumber: $product.attr('data-pn'),
        gtin: $product.attr('data-gtin'),
        linecode: $product.attr('data-whlc'),
        stocknumber: $product.attr('data-whsn'),
    });

    if ($quantity.length) {
        $quantity.val(quantity);
    }

    if ($product.find('.no-stock').length && $quantity.length) {
        $quantity.removeAttr('max');
    }

    var modalEl = $orderModal[0];
    if (modalEl && modalEl.parentNode !== document.body) {
        if (!$orderModal.data('paceOrderModalShelf')) {
            $orderModal.data('paceOrderModalShelf', $orderModal.parent());
        }
        document.body.appendChild(modalEl);
    }

    showModal($orderModal);
}

export function initOrdering() {
    $(document).on(
        'hidden.bs.modal.paceOrderItemReparent',
        '[id^="orderItemModal"]',
        function () {
            var $m = $(this);
            var $shelf = $m.data('paceOrderModalShelf');
            if ($shelf && $shelf.length && document.body.contains($shelf[0])) {
                $shelf[0].appendChild($m[0]);
            }
        }
    );

    // Browse grid: ensure add-to-order opens the picker even if submit handling misbehaves.
    $(document).on(
        'click',
        '.order-form:not(.ajax-form) input[type="submit"].product-order, .order-form:not(.ajax-form) .btn-add-to-order[type="submit"]',
        function (e) {
            var $form = $(this).closest('.order-form');
            if (isExplicitSingleOrderForm($form)) {
                return;
            }
            e.preventDefault();
            e.stopImmediatePropagation();
            openMultiOrderItemModal($form);
        }
    );

    // Delegated: browse shell replaces .browse-main-col via AJAX without re-running
    // initOrdering; direct .submit() would not bind new product cards.
    $(document).on('submit', '.order-form', function (e) {
        if (isExplicitSingleOrderForm($(this))) {
            return true;
        }

        e.preventDefault();
        e.stopPropagation();

        openMultiOrderItemModal($(this));
    });

    $('#orderModal form').on('keyup keypress', function (e) {
        var keyCode = e.keyCode || e.which;

        if (keyCode == 13) {
            e.preventDefault();
        }
    });

    // Delegated: .instant-order buttons live in product cards the browse shell
    // replaces via AJAX; a direct .click() would not bind re-rendered cards, so
    // the modal opens (via data-bs-toggle) but its body/URL never get populated.
    $(document).on('click', '.instant-order', function (e) {
        e.preventDefault();

        var $form = $(this).closest('form');
        var $submitButton = $form.find('[type="submit"]');
        var poIsRequired = $(this).attr('data-po-is-required');

        // Reset accumulated form data so reopening the modal doesn't double-append.
        _InstantOrderForm.data = new FormData();

        if (!$form.find('input[name="InstantOrder"]').length) {
            $form.prepend(
                '<input type="hidden" name="InstantOrder" value="1" />'
            );
        }

        var are_fields = false;

        if (poIsRequired === '1') {
            $('#po-field').removeClass('d-none');
            $('#po-num-label').addClass('required');
            $('#po-required-tag').removeClass('d-none');
            are_fields = true;
        } else {
            $('#po-field').addClass('d-none');
            $('#po-num-label').removeClass('required');
            $('#po-required-tag').addClass('d-none');
        }

        if ($(this).attr('data-price-match')) {
            $('#is-price-match').val('1');
            $('#price-match-fields').removeClass('d-none');
            if ($(this).attr('email-only')) {
                $('#is-email-only-price-match').val('1');
                $('#instantOrderModalLabel').html('Price Match Message');
                $('#inst-order-btn-label').html('Submit Price Match Message');
                $('#po-field').addClass('d-none');
                $('#po-num-label').removeClass('required');
                $('#po-required-tag').addClass('d-none');
            } else {
                $('#instantOrderModalLabel').html('Price Match Order');
                $('#inst-order-btn-label').html('Submit Price Match Order');
            }
            are_fields = true;
        } else {
            $('#instantOrderModalLabel').html('Instant Order');
            $('#is-price-match').val('0');
            $('#price-match-fields').addClass('d-none');
        }

        if (are_fields) {
            $('#are-you-sure').addClass('d-none');
        } else {
            $('#are-you-sure').removeClass('d-none');
        }

        var inv = parseInt($form.find('input[name="inv"]').val());
        var qty = parseInt($form.find('input[name="qty"]').val());
        if (qty > inv && !$(this).attr('email-only')) {
            $('#inst-modal-backorder-notice').removeClass('d-none');
            $('#inst-modal-backordered-num').html(qty - inv);
        } else {
            $('#inst-modal-backorder-notice').addClass('d-none');
            $('#inst-modal-backordered-num').html(0);
        }

        if ($(this).attr('email-only')) {
            _InstantOrderForm.url = $form
                .attr('action')
                .replace('add_item_to_order', 'emailonly_pricematch');
        } else {
            _InstantOrderForm.url = $form.attr('action');
        }
        _InstantOrderForm.data.append('qty', qty);
        _InstantOrderForm.data.append('inv', inv);
    });

    $(document).on('click', '.btn-submit-instant-order', function (e) {
        if (
            typeof _InstantOrderForm.url !== 'string' ||
            typeof _InstantOrderForm.data !== 'object'
        ) {
            return console.error(
                '_InstantOrderForm',
                'Invalid form data for instant order'
            );
        }

        var complete = true;
        var $button = $(this);
        var isPriceMatch = $('#is-price-match').val() === '1';
        var isEmailOnly = $('#is-email-only-price-match').val() === '1';
        var poIsRequired =
            $button.attr('data-po-required') === '1' && !isEmailOnly;
        var originalButtonText = $button.text();

        var $inputPoNumber = $('#instantOrderPoNumber');
        var poNumber = $inputPoNumber.val();
        if (typeof poNumber === 'undefined') {
            poNumber = '';
        }
        if (typeof poNumber === 'string' && poNumber.trim().length) {
            poNumber = poNumber.replaceAll(' ', '_').trim();
            _InstantOrderForm.data.append('PurchaseOrderNumber', poNumber);
        } else if (poIsRequired) {
            complete = false;
        }

        if (isPriceMatch) {
            var compName = $('#priceMatchCompetitorName').val().trim();
            var prcMtch = $('#priceMatchPrice').val().trim();
            var imgVal = $('#priceMatchImage').val();
            if (
                compName.length == 0 ||
                prcMtch.length == 0 ||
                imgVal.length == 0
            ) {
                complete = false;
            }
        }

        if (!complete) {
            Swal.fire({
                title: 'You must enter a value for all required fields to continue.',
                icon: 'warning',
                confirmButtonColor: '#b20000',
                confirmButtonText: 'OK',
            });
            return false;
        }

        if (
            parseInt($('#inst-modal-backordered-num').html()) > 0 &&
            !$('#inst-modal-backorder-ack').prop('checked')
        ) {
            Swal.fire({
                title: 'You must check the box acknowledging backordered items to continue.',
                icon: 'warning',
                confirmButtonColor: '#b20000',
                confirmButtonText: 'OK',
            });

            return false;
        }

        _InstantOrderForm.data.append('instant', 1);

        $.ajax({
            url: _InstantOrderForm.url,
            data: _InstantOrderForm.data,
            type: 'post',
            processData: false,
            contentType: false,
            dataType: 'json',
            beforeSend: function () {
                $button.prop('disabled', true);

                $button
                    .html(
                        '<i class="fa fa-circle-o-notch fa-spin"></i><span class="visually-hidden">Loading...</span> Submitting...'
                    )
                    .prop('disabled', true);
            },
            complete: function (response) {
                if (!response.hasOwnProperty('responseJSON')) {
                    console.log(response);
                    return false;
                }

                $button.text(originalButtonText).prop('disabled', true);

                var data = response.responseJSON;

                if (data.error) {
                    console.error('Could not submit order');
                    return false;
                }

                if (poNumber == '' && isPriceMatch) {
                    poNumber = 'pricematch';
                }

                var $auInput = $('#au');

                if (isPriceMatch) {
                    var priceMatchFormData = new FormData();
                    priceMatchFormData.append('IsPriceMatch', '1');
                    priceMatchFormData.append(
                        'IsEmailOnly',
                        isEmailOnly ? '1' : '0'
                    );
                    priceMatchFormData.append('PurchaseOrderNumber', poNumber);
                    priceMatchFormData.append('CompetitorName', compName);
                    priceMatchFormData.append('MatchPrice', prcMtch);
                    priceMatchFormData.append(
                        'PriceMatchImage',
                        $('#priceMatchImage')[0].files[0]
                    );
                    if (!isEmailOnly) {
                        priceMatchFormData.append('OrderRowID', data.order_id);
                    } else {
                        priceMatchFormData.append('aaia', data.aaia);
                        priceMatchFormData.append('pn', data.pn);
                    }
                    $.ajax({
                        url:
                            '/order/price_match_setup' +
                            ($auInput.length ? '?au=' + $auInput.val() : ''),
                        data: priceMatchFormData,
                        type: 'post',
                        processData: false,
                        contentType: false,
                        dataType: 'json',
                        // price_match_setup echoes 1 on success and 0 when validation
                        // or the move fails. This was read from `complete`, which fires
                        // for failures too - so a rejected upload still showed the
                        // success modal (or submitted the order) while session_value('pm')
                        // was never set and the evidence was silently dropped.
                        success: function (pm_response) {
                            if (!pm_response) {
                                $button
                                    .text(originalButtonText)
                                    .prop('disabled', false);
                                alert('Failed to submit price match');
                                return;
                            }
                            if (isPriceMatch && isEmailOnly) {
                                hideModal($button.closest('.modal'));
                                showModal($('#pmEmailOnlyModal'));
                            } else {
                                postInstantOrder(
                                    data.order_id,
                                    data.po_items,
                                    poNumber,
                                    true
                                );
                            }
                        },
                        error: function (pm_response) {
                            console.log(pm_response.responseText);
                            $button
                                .text(originalButtonText)
                                .prop('disabled', false);
                            alert('Failed to submit price match');
                        },
                    });
                } else {
                    postInstantOrder(
                        data.order_id,
                        data.po_items,
                        poNumber,
                        false
                    );
                }
            },
            error: function () {
                $button.text(originalButtonText).prop('disabled', false);
                alert('Failed to submit instant order');
            },
        });
    });

    $('.btn-quick-order').click(function () {
        var $orderModal = $('#orderModal');
        var $autocomplete = $(this)
            .closest('form')
            .find('.autocomplete-search');
        var $table = $orderModal.find('table');

        if ($autocomplete.val() != undefined && $autocomplete.val().trim().length > 0) {
            var $defaultRow = $table.find('.default-row');
            var $newRow = $defaultRow.clone();
            $newRow.insertBefore($defaultRow);
            $newRow
                .find('.multi-order-part-number')
                .val($autocomplete.val().trim());
            $newRow.removeClass('default-row');
            renameOrderRows($table);
        }
    });

    $('.order-dropdown').change(function () {
        var $orderNameField = $(this)
            .closest('form')
            .find('.js-input-order-name');
        var viewAsAccount = $('#vaa').length ? '?au=' + $('#vaa').val() : '';

        if ($(this).val() === '') {
            $orderNameField.val('');
            $orderNameField.closest('.mb-3').show();
        } else {
            $orderNameField.closest('.mb-3').hide();

            var orderId = $(this).val();
            var $orderModal = $('#orderModal');
            loadQuickOrderModalLinesFromOrder($orderModal, orderId);
        }
    });

    $('#orderModal').on('shown.bs.modal', function () {
        var $modal = $(this);
        window.setTimeout(function () {
            var $form = $modal.find('form');
            if ($form.attr('data-single-order') !== '1') {
                return;
            }
            var defaultId = $form.attr('data-default-order-rowid');
            if (!defaultId) {
                return;
            }
            var $tbody = $form.find('.multi-order-table tbody');
            if ($tbody.find('tr').not('.default-row').length > 0) {
                return;
            }
            loadQuickOrderModalLinesFromOrder($modal, defaultId);
        }, 0);
    });

    $(document)
        .on('click', '.multi-order-remove', function (e) {
            var $self = $(this);
            var $row = $self.closest('tr');
            var $table = $self.closest('.multi-order-table');
            var itemID = $self.attr('data-item-id');

            if (typeof itemID !== typeof undefined && itemID !== false) {
                Swal.fire({
                    title: 'Are you sure you want to remove this item?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#b20000',
                    confirmButtonText: 'Remove',
                }).then((result) => {
                    if (result.isConfirmed) {
                        $.ajax({
                            url: '/order/remove_item_from_order',
                            data: { ItemRowID: itemID },
                            type: 'post',
                            success: function () {
                                if (
                                    !$row.hasClass('default-row') &&
                                    $table.find('tr').length > 1
                                ) {
                                    $self.closest('tr').remove();
                                }

                                validateOrderRows($table);
                            },
                        });
                    }
                });
            } else {
                if (
                    !$row.hasClass('default-row') &&
                    $table.find('tr').length > 1
                ) {
                    $self.closest('tr').remove();
                }

                validateOrderRows($table);
            }
        })

        .on('click', '.btn-flag-order', function (e) {
            e.preventDefault();

            var $button = $(this);
            var $form = $button.closest('form');

            $.ajax({
                url: $form.attr('action'),
                data: $form.serialize(),
                type: 'post',
                success: function () {
                    if (!$button.parent().parent().hasClass('order-buttons')) {
                        var $dot = $button.closest('tr').find('.flag');

                        if ($dot.hasClass('flagged')) {
                            $dot.removeClass('flagged').addClass('unflagged');
                        } else {
                            $dot.removeClass('unflagged').addClass('flagged');
                        }
                    }

                    if ($button.val() == 'Unflag for Purchase') {
                        $button
                            .removeClass('btn-secondary')
                            .addClass('btn-warning')
                            .val('Flag for Purchase');
                        $form.attr('action', 'order/ajaxFlagForPurchase');
                    } else {
                        $button
                            .removeClass('btn-warning')
                            .addClass('btn-secondary')
                            .val('Unflag for Purchase');
                        $form.attr('action', 'order/ajaxUnflagForPurchase');
                    }
                },
            });
        })

        .on('click', '.flag', function () {
            var $self = $(this);
            var url = $self.hasClass('flagged')
                ? 'order/ajaxUnflagForPurchase'
                : 'order/ajaxFlagForPurchase';

            var $auInput = $('#au');

            if ($auInput.length) {
                url += '?au=' + $auInput.val();
            }

            $.ajax({
                url: url,
                data: { OrderRowID: $self.attr('data-id') },
                type: 'post',
                success: function () {
                    if ($self.hasClass('flagged')) {
                        $self
                            .removeClass('flagged')
                            .addClass('unflagged')
                            .attr('title', 'Flag for purchase');
                    } else {
                        $self
                            .removeClass('unflagged')
                            .addClass('flagged')
                            .attr('title', 'Unflag for purchase');
                    }
                },
            });
        });

    $('.multi-order-quantity, .order-form input[type="number"]').on(
        'change keyup paste input',
        function () {
            if ($(this).val() <= 0) {
                $(this).val('1');
            } else if (
                typeof $(this).attr('max') !== typeof undefined &&
                $(this).attr('max') !== false &&
                $(this).val() >= parseInt($(this).attr('max'))
            ) {
                $(this).val($(this).attr('max'));
            }
        }
    );

    $(document).on('change', '.order-item [data-order-qty]', function () {
        var $quantityElement = $(this);
        var $tableCell = $quantityElement.closest('td');
        var $maxQuantityElement = $tableCell.find('.po-max-qty');
        var $quantityLocationElement = $tableCell.find(
            '[data-order-qty-location]'
        );
        var $quantityError = $tableCell.find('.order-qty-error');
        var maxQuantity = null;

        if ($maxQuantityElement.length && $quantityLocationElement.length) {
            maxQuantity = parseInt($maxQuantityElement.text());

            if (!isNaN(maxQuantity)) {
                var totalUserQuantity = 0;

                $quantityElement
                    .closest('.order-item')
                    .find('[data-order-qty]')
                    .each(function () {
                        totalUserQuantity += parseInt($(this).val());
                    });

                if (totalUserQuantity != maxQuantity) {
                    $quantityError
                        .removeClass('d-none')
                        .parent()
                        .addClass('is-invalid');
                } else {
                    $quantityError
                        .addClass('d-none')
                        .parent()
                        .removeClass('is-invalid');
                }
            }
        } else if (
            isNaN($quantityElement.val()) ||
            $quantityElement.val() <= 0
        ) {
            $quantityElement.val('1');
        }

        if (
            typeof $quantityElement.attr('max') !== typeof undefined &&
            $quantityElement.attr('max') !== false &&
            $quantityElement.val() >= parseInt($quantityElement.attr('max')) &&
            !$quantityElement.closest('td').find('.quantity-tooltip').length
        ) {
            $quantityElement.val($quantityElement.attr('max'));

            $quantityElement
                .closest('td')
                .append(
                    '<span class="quantity-tooltip">Maximum ' +
                        $quantityElement.attr('max') +
                        '</span>'
                );

            setTimeout(function () {
                var $tooltip = $quantityElement
                    .closest('td')
                    .find('.quantity-tooltip');

                $tooltip.fadeOut(function () {
                    $tooltip.remove();
                });
            }, 1000);
        }

        calculateOrderCosts();

        var submit_button_orig_label = $('#submitOrder').val();
        var submit_button_was_disabled = $('#submitOrder').is('[disabled]');
        $('#submitOrder')
            .val('Save Changes')
            .removeClass('btn-success')
            .removeAttr('disabled')
            .addClass('btn-info');

    });

    if ($('.order-submit').length && $('#submitOrder').length) {
        $('#edit-order-name').click(function () {
            var $self = $(this);
            var $orderName = $self.parent();
            $orderName
                .hide()
                .prev('#order-name-form')
                .css({ display: 'inline' })
                .find('.js-input-order-name')
                .val($orderName.find('span').text());
        });

        $('#order-name-form').submit(function (e) {
            e.preventDefault();
            var $form = $(this);
            var $orderName = $form.next('#order-name');

            $.ajax({
                url: $form.attr('action'),
                type: 'post',
                data: $form.serialize(),
                complete: function () {
                    $form.hide();
                    $orderName
                        .show()
                        .find('span')
                        .text($form.find('.js-input-order-name').val());
                },
            });
        });

        var submit_button_orig_label = $('#submitOrder').val();
        var submit_button_was_disabled = $('#submitOrder').is('[disabled]');
        $('.order-submit #OrderNotes').keyup(function () {
            $('#submitOrder')
                .val('Save Changes')
                .removeClass('btn-success')
                .removeAttr('disabled')
                .addClass('btn-info');
        });

        $('#submitOrder').click(function (e) {
            if ($(this).val() === 'Save Changes') {
                e.preventDefault();

                $('input[name="Quantity"]').each(function (i, input) {
                    var $form = $(input).closest('form');

                    $.ajax({
                        url: $form.attr('action'),
                        data: $form.serialize(),
                        type: 'post',
                        beforeSend: function () {
                            $form
                                .parent()
                                .prepend(
                                    '<span class="badge bg-success">Saving</span>'
                                );
                        },
                        complete: function () {
                            $form.parent().find('.label').remove();
                        },
                    });
                });

                var $notesForm = $('#addNotes');

                $.ajax({
                    url: $notesForm.attr('action'),
                    data: $notesForm.serialize(),
                    type: 'post',
                    beforeSend: function () {
                        $notesForm
                            .find('label')
                            .append(
                                ' <span class="badge bg-success">Saving</span>'
                            );
                    },
                    complete: function () {
                        $notesForm.find('label .label').remove();
                    },
                });

                $('#submitOrder')
                    .val(submit_button_orig_label)
                    .removeClass('btn-info')
                    .addClass('btn-success');
                if (submit_button_was_disabled) {
                    $('#submitOrder').attr('disabled', 'disabled');
                }
            }
        });

        $('.btn-empty-order').click(function (e) {
            e.preventDefault();
            var $self = $(this);

            Swal.fire({
                title:
                    'Are you sure you want to remove all items from this ' +
                    customOrderText +
                    '?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#b20000',
                confirmButtonText: 'Empty ' + customOrderText,
            }).then((result) => {
                if (result.isConfirmed) {
                    var $form = $self.closest('form');

                    $.ajax({
                        url: $form.attr('action'),
                        data: $form.serialize(),
                        type: 'post',
                        success: function () {
                            window.location.href = window.location.href;
                        },
                    });
                }
            });
        });

        $('.btn-order-remove-item').click(function (e) {
            e.preventDefault();
            var $form = $(this).closest('form');
            var $row = $(this).closest('tr');
            var item = $(this).attr('data-item');

            Swal.fire({
                title: 'Are you sure you want to remove item ' + item + '?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#b20000',
                confirmButtonText: 'Remove',
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        url: $form.attr('action'),
                        data: $form.serialize(),
                        type: 'post',
                        success: function () {
                            $row.remove();
                            calculateOrderCosts();
                        },
                    });
                }
            });
        });
    }

    $('#reviewOrderForm').submit(function (e) {
        if (!validateCheckoutWarehouseSplit()) {
            e.preventDefault();
            return false;
        }
        var $form = $(this);
        var $button = $form.find('#submitPO');
        var $poNumber = $('#PurchaseOrderNumber');
        var $backorderAgreement = $('#backorderAgreement');
        var valid = true;
        var tmp = $(
            '<input type="hidden" name="' +
                this.name +
                '" value="' +
                $button.val() +
                '" />'
        ).appendTo($form);

        if (
            typeof $poNumber.attr('required') !== typeof undefined &&
            $poNumber.attr('required') !== false &&
            $poNumber.val().length == 0
        ) {
            valid = false;
            $poNumber
                .css({ 'border-color': '#b20000', 'background-color': 'pink' })
                .attr('placeholder', 'required');
        } else {
            $poNumber
                .css({ 'border-color': '#cccccc', 'background-color': 'white' })
                .removeAttr('placeholder');
        }

        if ($backorderAgreement.length && !$backorderAgreement.is(':checked')) {
            valid = false;
            $('#backorderAgreementText').after(
                '<span id="backorderAgreementError" class="text-danger"> Required!</span>'
            );
        } else {
            $('#backorderAgreementError').remove();
        }

        if (!valid) {
            tmp.remove();
            e.preventDefault();
            return false;
        }
    });

    $(document).on('click', '[data-order-remove-item]', function () {
        var $self = $(this);

        Swal.fire({
            title: 'Are you sure you want to remove this item?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#b20000',
            confirmButtonText: 'Remove',
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: 'order/remove_item_from_order',
                    type: 'post',
                    data: {
                        ItemRowID: $self.attr('data-order-remove-item'),
                    },
                    success: function () {
                        window.location.reload();
                    },
                });
            }
        });
    });

    initQuickOrderModal();
}
